import { Component } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { LayoutService } from '../../services/layout.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { SharedService } from 'src/app/shared/services/shared.service';

interface Breadcrumb {
    language_key: any;
    icon: any;
    url?: string;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent extends BaseComponent {
    triggerApi: boolean = false;
    showTimesheetComponent: boolean = false;
    showExpenseComponent: boolean = false;
    icon: any;
    phase: any;
    stateOptions: any
    private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);

    readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

    constructor(private router: Router, public translation_service: TranslationService, public layoutService: LayoutService,
        private shared_service: SharedService
    ) {
        super()
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(event => {
            const root = this.router.routerState.snapshot.root;
            const breadcrumbs: Breadcrumb[] = [];
            this.addBreadcrumb(root, [], breadcrumbs);
            this._breadcrumbs$.next(breadcrumbs);
        });
        this.shared_service.accountSettings$.subscribe(value => {
            this.phase = value;
            this.stateOptions = [
                {
                    label: 'Timesheet', value: 1, command: () => {
                        this.onTimesheet();
                    }
                },
                {
                    label: this.phase.account_cost_heading, value: 2, command: () => {
                        this.onExpense();
                    }
                }
            ]
        });
    }

    private addBreadcrumb(route: ActivatedRouteSnapshot, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
        const routeUrl = parentUrl.concat(route.url.map(url => url.path));
        const breadcrumb = route.data['breadcrumb'];
        const parentBreadcrumb = route.parent && route.parent.data ? route.parent.data['breadcrumb'] : null;
        if (breadcrumb && breadcrumb !== parentBreadcrumb) {
            breadcrumbs.push({
                icon: route.data['icon'],
                language_key: route.data['breadcrumb'],
                url: '/' + routeUrl.join('/')
            });
            // breadcrumbs[0].icon = route.data['icon'];
        }

        if (route.firstChild) {
            this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
        }
    }

    get visible(): boolean {
        return this.layoutService.state.TimesheetVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.TimesheetVisible = _val;
    }

    onTimesheet() {
        this.layoutService.showTimesheetConfigSidebar(true);
        this.showTimesheetComponent = true;
        this.showExpenseComponent = false;
        this.triggerApiCall();
    }

    onExpense() {
        this.layoutService.showTimesheetConfigSidebar(true);
        this.showExpenseComponent = true;
        this.showTimesheetComponent = false;
        this.triggerApiCall();
    }

    triggerApiCall() {
        this.triggerApi = !this.triggerApi;
    }

    handleClose(event: boolean) {
        this.visible = !event;
        this.showTimesheetComponent = false;
        this.triggerApi = false;
        this.layoutService.showFilterConfigSidebar(this.visible);
    }

    onRedirct(url: any, first: any) {
        if (!first) {
            if (this.router.url.includes(this.routingModuleType.interactions + '/' + this.routingInteractionsSubModuleType.contacts)) {
                this.router.navigate([this.routingModuleType.interactions, this.routingInteractionsSubModuleType.contacts]);
            } else if (this.router.url.includes(this.routingOrganizationSubModuleType.costs)) {
                this.router.navigate([this.routingModuleType.organization, this.routingOrganizationSubModuleType.costs]);
            } else if (this.router.url.includes(this.routingOrganizationSubModuleType.staffs)) {
                this.router.navigate([this.routingModuleType.organization, this.routingOrganizationSubModuleType.staffs]);
            } else if (this.router.url.includes(this.routingOrganizationSubModuleType.tasks)) {
                this.router.navigate([this.routingModuleType.organization, this.routingOrganizationSubModuleType.tasks]);
            } else {
                this.router.navigate([url]);
            }
        }
    }
}